import axios from 'axios'
import store from '@/store'

const API = {
  getData (params) {
    return new Promise(function (resolve, reject) {
      if (!params.slug) {
        reject(new Error('no url provided'))
      }
      let url = process.env.VUE_APP_API_PATH + params.slug
      let startParams = {}
      let headers = {}

      if (store.state.apiKey) {
        startParams.api_token = store.state.apiKey
        headers =  {
          'Accept': 'application/json',
          'Authorization':'Bearer ' + store.state.apiKey
        }
      }
      console.log('headers')
      console.log(headers)
      let apiParams = false
      if (params.apiParams) {
        apiParams = { ...startParams, ...params.apiParams }
      } else {
        apiParams = startParams
      }
      axios.post(url, apiParams, headers)
        .then(
          (response) => {
            let {data} = response
            resolve(data)
          },
          (error) => {
            reject(new Error(error))
          })
    })
  }
}

export default API
